import Link from "next/link";
import React from "react";
import { FaUnlockAlt, FaBookOpen, FaGooglePlay, FaApple } from "react-icons/fa";

export default function Download({ data }) {
  return (
    <>
      <section className="container">
        <div className="bg-[#141414] py-16 shadow-[8px_8px_0px_#FFD338] lg:px-0 px-4">
          <div className="flex lg:flex-nowrap flex-wrap justify-center lg:items-end lg:gap-8 xl:gap-12 gap-6">
            <div className="text-center md:text-left text-white">
              {data?.subHeading && (
                <h3 className="text-xl md:text-[29px]">{data?.subHeading}</h3>
              )}
              {data?.heading && (
                <h2 className="text-2xl md:text-[34px] lg:text-[48px] font-bold mt-4">
                  {data?.heading}
                </h2>
              )}
            </div>

            <div className="flex flex-wrap justify-center items-end md:justify-end gap-4">
              <div className="flex items-center gap-2 bg-[#FFD338] px-4 rounded-md py-2">
                <FaGooglePlay className="md:text-3xl text-2xl" />
                <div>
                  GET IT ON
                  <div>
                    <Link
                      href="https://play.google.com/store/apps/details?id=in.clclive.app"
                      target="_blank"
                      className=" text-black    rounded-md  gap-2 font-semibold text-sm md:text-base"
                    >
                      <span className="font-medium block md:text-[30.12px] text-xl">
                        Google Play
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-[#FFD338] px-4 rounded-md py-2">
                <FaApple className="md:text-5xl text-3xl" />
                <div>
                  Download on the
                  <div>
                    <Link
                      href="https://apps.apple.com/in/app/clc-live-for-iit-jee-and-neet/id6737020863"
                      target="_blank"
                      className=" text-black    rounded-md  gap-2 font-semibold text-sm md:text-base"
                    >
                      <span className="font-medium block md:text-[30.12px] text-xl">
                        App Store
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              {/* <div className="flex items-center gap-2 bg-[#FFD338] px-4 rounded-md">
                  <FaApple className="text-3xl" />
                  <Link
                    href="#"
                    className=" text-black px-4 py-2 md:px-2   rounded-md f gap-2 font-semibold text-sm md:text-base"
                  >
                    Download on the <br />{" "}
                    <span className="font-bold md:text-xl text-lg">
                      App Store
                    </span>
                  </Link>
                </div> */}
            </div>
          </div>
        </div>

        {/* <div className="absolute bottom-0 left-0 w-full h-full bg-[#FBD242] z-0 translate-y-2 translate-x-2"></div> */}
      </section>
    </>
  );
}
